import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { MarkdownLite } from "@/components/MarkdownLite";

export function ExplainButton({ text, kind = "actualité", label, testid = "explain-btn" }) {
  const { t, lang } = useLang();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [explanation, setExplanation] = useState("");

  const run = async () => {
    setOpen(true);
    setLoading(true);
    setExplanation("");
    try {
      const { data } = await api.post("/ai/explain", { text, kind, lang });
      setExplanation(data.explanation);
    } catch (e) {
      toast.error(t("eb.fail"));
      setExplanation("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={run}
        className="h-7 gap-1.5 px-2 text-xs text-blue-400 hover:bg-blue-500/10 hover:text-blue-300"
        data-testid={testid}
      >
        <Sparkles className="h-3.5 w-3.5" /> {label || t("eb.label")}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg bg-[#12151C] border-slate-800" data-testid="explain-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 font-heading">
              <Sparkles className="h-4 w-4 text-blue-400" /> {t("eb.title")}
            </DialogTitle>
          </DialogHeader>
          {loading ? (
            <div className="flex items-center gap-2 py-8 text-slate-400">
              <Loader2 className="h-4 w-4 animate-spin" /> {t("eb.analyzing")}
            </div>
          ) : (
            <div className="max-h-[60vh] overflow-y-auto text-sm text-slate-200">
              <MarkdownLite text={explanation} />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
